import React, {useContext} from 'react';
import styled from 'styled-components';
import {Button, Text, Tag, Heading} from '../../Widgets';
import {Check, Close} from '@styled-icons/material';
import OrderItemsModal, {metadata} from '../../Modals/OrderItems';
import useOrderDisplayState from '../../hooks/use-order-display-state';
import {Context} from '../../AppContext';
const appConfig = require('../../data.json');
const MODAL_TITLES = {
  review: '審稿',
  production: '印製',
  logistic: '物流',
};

export default function StatusBar({order}) {
  const app = useContext(Context);

  let rejected = order.is_item_rejected;
  let {step} = useOrderDisplayState({
    display_state: order.display_state,
    payment_type: order.payment_type,
    payment_subtype: order.payment_subtype,
    order_type: order.order_type,
    logistics: order.logistics,
    payment_status: order.payment_status,
  });

  return (
    <Container>
      <div className="cell">
        <ItemWrapper
          isActived={step >= 1}
          isCurrent={step === 0}
          isRejected={rejected}>
          <p className="title">訂單成立</p>
          <div className="line-wrapper">
            <div className="point">
              <Check color="white" size={20} />
            </div>
            <div className="line"></div>
          </div>
          <div className="sub-section">
            <p className="subtitle">訂單成立</p>
            <p className="data">{`成立時間`}</p>
            <p className="data">{`${order.created.slice(0, 10)}`}</p>
          </div>
        </ItemWrapper>
      </div>
      <div className="cell">
        <ItemWrapper
          isActived={step >= 2}
          isCurrent={step === 1}
          isRejected={rejected}>
          <p className="title">付款階段</p>
          <div className="line-wrapper">
            <div className="point">
              <Check color="white" size={20} />
            </div>
            <div className="line"></div>
          </div>
          <div className="sub-section">
            {order.payment_status === 'success' && (
              <p className="subtitle">付款成功</p>
            )}
          </div>
        </ItemWrapper>
      </div>
      <div className="cell">
        <ItemWrapper
          isActived={step >= 3}
          isCurrent={step === 2}
          isRejected={rejected}>
          <p className="title">審稿階段</p>
          <div className="line-wrapper">
            <div className="point">
              {rejected && step === 2 ? (
                <Close color="white" size={20} />
              ) : (
                <Check color="white" size={20} />
              )}
            </div>
            <div className="line"></div>
          </div>
          <div className="sub-section">
            {step >= 3 && <p className="subtitle">審稿完成</p>}
            <Button
              size="small"
              onClick={() =>
                app.actions.setModal({
                  content: <OrderItemsModal type="review" order={order} />,
                  ...metadata,
                  title: <Heading>{MODAL_TITLES['review']}狀態</Heading>,
                })
              }>
              稿件資訊
            </Button>
          </div>
        </ItemWrapper>
      </div>
      <div className="cell">
        <ItemWrapper
          isActived={step >= 4}
          isCurrent={step === 3}
          isRejected={rejected}>
          <p className="title">印製階段</p>
          <div className="line-wrapper">
            <div className="point">
              <Check color="white" size={20} />
            </div>
            <div className="line"></div>
          </div>
          <div className="sub-section">
            {step >= 4 && <p className="subtitle">商品已入庫</p>}
            <Button
              size="small"
              onClick={() =>
                app.actions.setModal({
                  content: <OrderItemsModal type="production" order={order} />,
                  ...metadata,
                  title: <Heading>{MODAL_TITLES['production']}狀態</Heading>,
                })
              }>
              商品資訊
            </Button>
          </div>
        </ItemWrapper>
      </div>

      <div className="cell">
        <ItemWrapper
          isActived={step >= 5}
          isCurrent={step === 4}
          isRejected={rejected}>
          <p className="title">出貨階段</p>
          <div className="line-wrapper">
            <div className="point">
              <Check color="white" size={20} />
            </div>
            <div className="line"></div>
          </div>
          <div className="sub-section">
            {step >= 5 && <p className="subtitle">已到貨/已自取</p>}
            <Button
              size="small"
              onClick={() =>
                app.actions.setModal({
                  content: <OrderItemsModal type="logistic" order={order} />,
                  ...metadata,
                  title: <Heading>{MODAL_TITLES['logistic']}狀態</Heading>,
                })
              }>
              物流資訊
            </Button>
          </div>
        </ItemWrapper>
      </div>

      <div className="cell">
        <ItemWrapper isActived={step >= 6} isCurrent={step === 5}>
          <p className="title">訂單完成</p>
          <div className="line-wrapper">
            <div className="point">
              <Check color="white" size={20} />
            </div>
          </div>
          {order.complete_time && (
            <div>
              <p className="data">{`完成時間`}</p>
              <p className="data">
                {order.complete_time.slice(0, 16).replace('T', ' ')}
              </p>
            </div>
          )}
        </ItemWrapper>
      </div>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  align-items: flex-start;

  & > .cell {
    flex: 1 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  @media only screen and (max-width: ${appConfig.breakpoints.sm}px) {
    flex-direction: column;
    padding: 0 20px;
    background-color: #f0f0f0;
    border-bottom: solid 1px #ccc;

    & > .cell {
      align-items: flex-start;
    }
  }
`;

const ItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  width: 100%;

  @media only screen and (max-width: ${appConfig.breakpoints.sm}px) {
    flex-direction: row;
    height: 100px;

    & > div,
    p {
      margin-right: 10px;
      margin-bottom: 0;
    }
  }

  & > .line-wrapper {
    margin-bottom: 15px;
    text-align: center;
    & > .line {
      position: absolute;
      width: calc(100% - 25px);
      height: 5px;
      top: 46px;
      left: calc(50% + 12.5px);
      background-color: ${(props) =>
        props.isRejected && props.isActived
          ? '#C24C4C'
          : props.isActived
          ? appConfig.colors.main
          : '#cbcbcb'};
    }

    & > .point {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 25px;
      width: 25px;
      border-radius: 50%;
      border: ${(props) =>
        props.isRejected && props.isCurrent
          ? 0
          : props.isCurrent
          ? 'solid 4px' + appConfig.colors.main
          : props.isActived
          ? 0
          : 'solid 4px #cbcbcb'};
      background-color: ${(props) =>
        props.isRejected && (props.isActived || props.isCurrent)
          ? '#C24C4C'
          : props.isCurrent
          ? 'white'
          : props.isActived
          ? appConfig.colors.main
          : 'white'};
    }

    & > .sub-section {
      width: 90px;
      text-align: center;
    }

    @media only screen and (max-width: ${appConfig.breakpoints.sm}px) {
      margin-bottom: 0;

      & > .line {
        width: 5px;
        height: calc(100px - 25px);
        top: calc(50% + 12.5px);
        left: 76px;
      }
    }
  }

  & > p {
    font-size: 13px;
    color: ${(props) => (props.isActived ? '#444444' : '#cbcbcb')};
  }

  & > .title {
    font-size: 14px;
    color: #595757;
  }

  & .subtitle {
    font-size: 12px;
    color: #595757;
    text-align: center;
  }

  & .data {
    font-size: 8px;
    color: #9fa0a0;
    text-align: center;
  }

  & .hint {
    color: red;
  }
`;
